import type { en } from './en.ts';

/**
 * Spanish catalog.
 *
 * The annotation is the whole safety mechanism: `Record<keyof typeof en, string>`
 * makes `tsc` fail if any key here is missing. Adding an English string without its
 * Spanish counterpart breaks the build instead of shipping an unreadable screen.
 *
 * NEEDS NATIVE REVIEW BEFORE THE PILOT. This is competent Mexican-Spanish warehouse
 * vocabulary, but the removal-from-service wording carries legal weight and the
 * checklist terms are trade-specific. A native speaker who knows forklifts should read
 * it before it goes in front of an operator.
 */
export const es: Record<keyof typeof en, string> = {
  // ---- chrome ----
  app_name: 'TES Inspect',
  language_english: 'English',
  language_spanish: 'Espanol',
  back: 'Atras',
  cancel: 'Cancelar',
  continue: 'Continuar',
  submit: 'Enviar',
  retry: 'Intentar de nuevo',

  // ---- connection state ----
  status_online: 'En linea',
  status_offline: 'Sin senal - se enviara cuando haya senal',
  status_sent: 'Enviado',
  status_saved_on_phone: 'Guardado en este telefono',
  status_send_failed: 'No se pudo enviar - avise a su supervisor',
  queued_one: '{count} inspeccion esperando enviarse',
  queued_other: '{count} inspecciones esperando enviarse',

  // ---- truck landing ----
  truck_heading: 'Montacargas {assetNumber}',
  truck_last_inspected: 'Ultima inspeccion {time} por {operator}',
  truck_never_inspected: 'Aun sin inspeccionar',
  truck_already_inspected_today: 'Inspeccionado hoy a las {time} por {operator}',
  truck_out_of_service: 'Reportado fuera de servicio a las {time}',
  action_daily_checklist: 'Inspeccion diaria',
  action_report_problem: 'Reportar un problema',
  action_inspect_again: 'Inspeccionar otra vez',

  // ---- identifying the operator ----
  operator_pick_name: 'Quien es usted?',
  operator_search: 'Busque su nombre',
  pin_title: 'Ingrese su PIN',
  pin_wrong: 'El PIN no coincide. Intente de nuevo.',
  pin_locked: 'Demasiados intentos. Espere {minutes} minutos o pida ayuda a su supervisor.',
  not_you: 'No es usted? Cambiar de operador',

  // ---- hour meter ----
  hour_meter_title: 'Lectura del horometro',
  hour_meter_hint: 'Ultima lectura: {hours} h',
  hour_meter_skip: 'No se puede leer',

  // ---- checklist ----
  checklist_title: 'Revision diaria',
  checklist_ok: 'Bien',
  checklist_defect: 'Falla',
  checklist_na: 'N/A',
  checklist_finish: 'Todo lo demas bien - Terminar',
  checklist_scroll_first: 'Primero revise toda la lista',
  checklist_attention_items: 'Revise estos dos con cuidado',

  // ---- defects ----
  defect_title: 'Que esta mal?',
  defect_describe: 'Describa el problema',
  defect_photo_required: 'Se requiere una foto',
  defect_take_photo: 'Tomar foto',
  defect_save: 'Guardar falla',
  problem_safe_to_operate: 'Es seguro seguir operando?',
  problem_category: 'Que tipo de problema?',

  // ---- removal from service ----
  osha_tag_out: 'NO OPERAR - FUERA DE SERVICIO',
  osha_notice_heading: 'Este montacargas debe sacarse de servicio',
  osha_citation: '29 CFR 1910.178(p)(1)',
  osha_acknowledge: 'Ya avise a mi supervisor',
  osha_call_supervisor: 'Llamar al supervisor',

  // ---- receipts ----
  receipt_sent_ok: 'Enviado - el montacargas puede operar.',
  receipt_saved_offline: 'Guardado en este telefono. Se enviara cuando haya senal.',
  receipt_defect_sent: 'Reportado. Servicio TES y su gerente ya fueron notificados.',
  receipt_defect_offline: 'Guardado. Su gerente sera notificado cuando haya senal.',

  // ---- things that went wrong ----
  tag_unknown_title: 'Esta etiqueta aun no esta configurada',
  tag_unknown_body: 'Lea este codigo a su supervisor: {code}',
  tag_unknown_report: 'Reportar a TES',
  tag_retired_title: 'Esta etiqueta fue reemplazada',
  tag_retired_body: 'Busque la etiqueta nueva en el techo protector.',
  wrong_company_title: 'Este montacargas es de otra empresa',
  wrong_company_body: 'Pregunte a su supervisor.',
  no_signal_title: 'No se puede revisar ahora',
  no_signal_body: 'Sin senal. Conectese a Wi-Fi o salga afuera, luego escanee otra vez.',
};
